import React from 'react';
import { Outlet } from 'react-router-dom';

const EnterprisesRouter: React.FC = () => <Outlet />;

export default EnterprisesRouter;
